module.exports = __webpack_public_path__ + "static/media/edit-alt.7bc55760.svg";